import React from "react";
import Loader from "../../../../Components/Atoms/Loader/Loader";
import { useParams, useSearchParams } from "react-router-dom";
import { useState } from "react";
import { useEffect } from "react";
import { getSupportedLanguages } from "../../../../Contexts/APIs/Lookups/SupportedLanguages";
import { toast } from "react-toastify";
import FreelancerLevelsDetailsTemplate from "../../../../Templates/Main/Levels/Freelancer/FreelancerDetails.template";
import { getFreelancerLevelsDetails } from "../../../../Contexts/APIs/Levels/Freelancer/freelancer";

function FreelancerLevelsDetailsPage({roles}) {
  let [searchParams] = useSearchParams();
  const id = searchParams.get("id");
  const [freelancersLevelsData, setFreelancersLevelsData] = useState({});
  const [openLoader, setOpenLoader] = useState(false);
  const [supportedLanguages, setSupportedLanguages] = useState([]);
  const [supportLang, setSupportLang] = useState("en");

  const getFreelancerLevels = async (notification_id) => {
    setOpenLoader(true);
    const { res, err } = await getFreelancerLevelsDetails(notification_id);
    if (res) {
      setFreelancersLevelsData(res?.data?.level);
    }
    if (err) {
      toast.error(err);
    }
    setOpenLoader(false);
  };

  const getLanguages = async () => {
    const { res, err } = await getSupportedLanguages();
    if (res) {
      setSupportedLanguages(res?.data?.supported_locales);
    }
  };

  useEffect(() => {
    id && getFreelancerLevels(id);
    getLanguages({});
  }, [id]);
  useEffect(() => {
    getLanguages({});
  }, []);
  const updateSupportedLang = (e, languages) => {
    setSupportLang(e.target.value);
  };
  return (
    <>
      <Loader open={openLoader} />
      <FreelancerLevelsDetailsTemplate
        freelancersLevelsData={freelancersLevelsData}
        supportedLanguages={supportedLanguages}
        updateSupportedLang={updateSupportedLang}
        supportLang={supportLang}
        roles={roles}
      />
    </>
  );
}

export default FreelancerLevelsDetailsPage;
